import { z } from 'zod/v4';
export var EBoksRecipientType;
(function (EBoksRecipientType) {
    // Legacy: kept to read earlier dispatches and deliverability attempts
    EBoksRecipientType["KVHX"] = "KVHX";
    EBoksRecipientType["AddressId"] = "ADDRESS_ID";
    EBoksRecipientType["CentralRegisterId"] = "CENTRAL_REGISTER_ID";
})(EBoksRecipientType || (EBoksRecipientType = {}));
export const EBoksRecipientSchema = z.union([
    z.object({
        type: z.literal(EBoksRecipientType.KVHX),
        firstName: z.string(),
        lastName: z.string(),
        kvhx: z.string().nullable(),
    }),
    z.object({
        type: z.literal(EBoksRecipientType.AddressId),
        firstName: z.string(),
        lastName: z.string(),
        addressId: z.string(),
    }),
    z.object({
        type: z.literal(EBoksRecipientType.CentralRegisterId),
        centralRegisterId: z.coerce.string(),
        isCompany: z.boolean(),
    }),
]);
//# sourceMappingURL=eboks.js.map